export default "__VITE_ASSET__68cfe695__"